import * as Icons from "lucide-react";

// Render a lucide icon by string name. Falls back to a dot.
export default function Icon({ name, ...props }) {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp {...props} />;
}
